
import { useState } from 'react';

interface FloorData {
  id: string;
  floor: string;
  label: string;
  color: string;
  icon: string;
  title: string;
  subtitle: string;
  description: string;
  totalArea: string;
  image: string;
  facilities: { name: string; icon: string; detail: string }[];
  highlights: string[];
}

const floorData: FloorData[] = [
  {
    id: 'f1',
    floor: '1F',
    label: '필로티',
    color: 'from-teal-600 to-teal-500',
    icon: 'ri-door-open-line',
    title: '필로티 공개공지',
    subtitle: '개방형 커뮤니티 공간',
    description:
      '1층은 필로티 구조로 설계되어 건물 전면을 공개공지로 조성합니다. 고급 라운지와 팝업존을 배치하여 지역 주민과 방문객 모두에게 열린 공간을 제공합니다.',
    totalArea: '약 1,200㎡',
    image:
      'https://public.readdy.ai/ai/img_res/dabb2784807d6597d599e00e38cb304f.jpg',
    facilities: [
      { name: '프리미엄 라운지', icon: 'ri-sofa-line', detail: '약 320㎡' },
      { name: '팝업 스토어 존', icon: 'ri-store-2-line', detail: '약 280㎡' },
      { name: '커뮤니티 홀', icon: 'ri-group-line', detail: '약 200㎡' },
      { name: '안내 데스크', icon: 'ri-customer-service-line', detail: '약 60㎡' },
      { name: '공개공지 광장', icon: 'ri-landscape-line', detail: '약 340㎡' },
    ],
    highlights: [
      '24시간 개방형 공간',
      '지역 주민 자유 이용',
      '계절별 팝업 이벤트 운영',
      '장애인 접근성 완비',
    ],
  },
  {
    id: 'f2',
    floor: '2F',
    label: '메인샵',
    color: 'from-amber-600 to-amber-500',
    icon: 'ri-shopping-bag-line',
    title: '메인샵 상업시설',
    subtitle: '프리미엄 리테일 & F&B',
    description:
      '2층에는 프리미엄 리테일 매장과 카페, 레스토랑 등 다양한 상업시설이 입점합니다. 서초동의 새로운 쇼핑 명소로 자리매김할 것입니다.',
    totalArea: '약 1,800㎡',
    image:
      'https://readdy.ai/api/search-image?query=architectural%20floor%20plan%20blueprint%20of%20luxury%20commercial%20retail%20floor%20with%20premium%20shops%20and%20restaurant%20layout%2C%20modern%20shopping%20mall%20floor%20plan%20with%20store%20units%20and%20dining%20areas%2C%20clean%20professional%20architectural%20drawing%20with%20amber%20accent%20annotations%20and%20furniture%20placement&width=900&height=600&seq=floor-plan-2f-v2&orientation=landscape',
    facilities: [
      { name: '프리미엄 리테일', icon: 'ri-shopping-bag-line', detail: '6개 매장' },
      { name: '카페 & 베이커리', icon: 'ri-cup-line', detail: '3개 매장' },
      { name: '레스토랑', icon: 'ri-restaurant-line', detail: '4개 매장' },
      { name: '편의시설', icon: 'ri-service-line', detail: '약 120㎡' },
      { name: '공용 테라스', icon: 'ri-plant-line', detail: '약 180㎡' },
    ],
    highlights: [
      '프리미엄 브랜드 유치',
      '야외 테라스 다이닝',
      '발렛 서비스 연계',
      '1층 광장과 연결 동선',
    ],
  },
  {
    id: 'f3',
    floor: '3F',
    label: '스마트시설',
    color: 'from-emerald-600 to-emerald-500',
    icon: 'ri-cpu-line',
    title: '스마트 공공시설 (3층)',
    subtitle: '주민 개방형 첨단 시설',
    description:
      '3층은 공공기여 시설로 지역 주민 누구에게나 개방됩니다. 스마트 피트니스, 공유 오피스, 디지털 도서관 등 첨단 시설을 무료 또는 저렴한 비용으로 이용할 수 있습니다.',
    totalArea: '약 1,600㎡',
    image:
      'https://readdy.ai/api/search-image?query=architectural%20floor%20plan%20blueprint%20of%20smart%20public%20facility%20floor%20with%20fitness%20center%20and%20coworking%20space%20layout%2C%20modern%20community%20center%20floor%20plan%20with%20digital%20library%20and%20meeting%20rooms%2C%20clean%20professional%20architectural%20drawing%20with%20green%20accent%20annotations&width=900&height=600&seq=floor-plan-3f-v2&orientation=landscape',
    facilities: [
      { name: '스마트 피트니스', icon: 'ri-boxing-line', detail: '약 400㎡' },
      { name: '공유 오피스', icon: 'ri-computer-line', detail: '약 350㎡' },
      { name: '디지털 도서관', icon: 'ri-book-open-line', detail: '약 280㎡' },
      { name: '다목적 회의실', icon: 'ri-presentation-line', detail: '4개실' },
      { name: '키즈 존', icon: 'ri-emotion-happy-line', detail: '약 200㎡' },
    ],
    highlights: [
      '주민 무료 개방',
      'AI 운동 코칭 시스템',
      '24시간 무인 운영',
      'IoT 기반 시설 관리',
    ],
  },
  {
    id: 'f4',
    floor: '4F',
    label: '문화시설',
    color: 'from-rose-600 to-rose-500',
    icon: 'ri-palette-line',
    title: '스마트 공공시설 (4층)',
    subtitle: '문화 & 웰니스 공간',
    description:
      '4층은 문화와 웰니스에 특화된 공공기여 시설입니다. 갤러리, 요가 스튜디오, 명상실 등 심신의 건강을 위한 다양한 프로그램이 운영됩니다.',
    totalArea: '약 1,600㎡',
    image:
      'https://readdy.ai/api/search-image?query=architectural%20floor%20plan%20blueprint%20of%20cultural%20and%20wellness%20facility%20floor%20with%20gallery%20and%20yoga%20studio%20layout%2C%20modern%20wellness%20center%20floor%20plan%20with%20meditation%20room%20and%20art%20exhibition%20space%2C%20clean%20professional%20architectural%20drawing%20with%20rose%20accent%20annotations&width=900&height=600&seq=floor-plan-4f-v2&orientation=landscape',
    facilities: [
      { name: '갤러리 & 전시실', icon: 'ri-gallery-line', detail: '약 350㎡' },
      { name: '요가 & 필라테스', icon: 'ri-mental-health-line', detail: '약 250㎡' },
      { name: '명상 & 힐링룸', icon: 'ri-leaf-line', detail: '약 150㎡' },
      { name: '문화 강좌실', icon: 'ri-mic-line', detail: '3개실' },
      { name: '카페테리아', icon: 'ri-cup-line', detail: '약 180㎡' },
    ],
    highlights: [
      '월간 기획 전시 운영',
      '전문 강사 프로그램',
      '주민 문화 행사 개최',
      '3층과 내부 계단 연결',
    ],
  },
  {
    id: 'f5',
    floor: '5-7F',
    label: '주차장',
    color: 'from-slate-600 to-slate-5',
    icon: 'ri-parking-box-line',
    title: '방문객 전용 주차장',
    subtitle: '강남3구 주차난 해소',
    description:
      '5층부터 7층까지 3개 층에 걸쳐 대규모 방문객 전용 주차장을 건설합니다. 스마트 주차 시스템과 전기차 충전 인프라를 완비하여 강남3구의 만성적인 주차난 해소에 기여합니다.',
    totalArea: '약 4,800㎡ (3개 층)',
    image:
      'https://readdy.ai/api/search-image?query=architectural%20floor%20plan%20blueprint%20of%20modern%20smart%20parking%20garage%20floor%20with%20organized%20parking%20spaces%20and%20EV%20charging%20stations%20layout%2C%20contemporary%20parking%20structure%20floor%20plan%20with%20vehicle%20circulation%20paths%20and%20smart%20system%20indicators%2C%20clean%20professional%20architectural%20drawing%20with%20gray%20accent%20annotations&width=900&height=600&seq=floor-plan-5f-v2&orientation=landscape',
    facilities: [
      { name: '일반 주차면', icon: 'ri-car-line', detail: '420대' },
      { name: '전기차 충전소', icon: 'ri-charging-pile-line', detail: '80대' },
      { name: '장애인 주차면', icon: 'ri-wheelchair-line', detail: '25대' },
      { name: '여성 전용 주차면', icon: 'ri-women-line', detail: '30대' },
      { name: '오토바이 주차면', icon: 'ri-motorbike-line', detail: '50대' },
    ],
    highlights: [
      'AI 빈자리 안내 시스템',
      '무인 정산 시스템',
      '층별 180대 이상 수용',
      'CCTV 24시간 모니터링',
    ],
  },
  {
    id: 'f8',
    floor: '8F+',
    label: '레지던스',
    color: 'from-teal-700 to-teal-600',
    icon: 'ri-home-heart-line',
    title: '프리미엄 레지던스 오피스텔',
    subtitle: '스마트 홈 하이엔드 주거',
    description:
      '8층 이상에는 스마트 홈 자동화가 적용된 프리미엄급 레지던스 오피스텔이 배치됩니다. 옥상 정원과 연계된 최고급 주거 환경으로 서초동 최고의 라이프스타일을 제공합니다.',
    totalArea: '세대당 84~145㎡',
    image:
      'https://readdy.ai/api/search-image?query=architectural%20floor%20plan%20blueprint%20of%20luxury%20premium%20residence%20unit%20with%20smart%20home%20system%20layout%2C%20modern%20high-end%20apartment%20floor%20plan%20with%20bedroom%20living%20room%20kitchen%20and%20balcony%2C%20clean%20professional%20architectural%20drawing%20with%20teal%20accent%20annotations%20and%20furniture%20placement&width=900&height=600&seq=floor-plan-8f-v2&orientation=landscape',
    facilities: [
      { name: '84㎡ 타입 A', icon: 'ri-layout-4-line', detail: '2룸 / 12세대' },
      { name: '107㎡ 타입 B', icon: 'ri-layout-3-line', detail: '3룸 / 8세대' },
      { name: '128㎡ 타입 C', icon: 'ri-layout-2-line', detail: '3룸+서재 / 6세대' },
      { name: '145㎡ 펜트하우스', icon: 'ri-vip-crown-line', detail: '4룸 / 4세대' },
      { name: '옥상 정원', icon: 'ri-plant-line', detail: '약 800㎡' },
    ],
    highlights: [
      '전 세대 스마트 홈 시스템',
      '3.2m 층고 프리미엄 설계',
      '서초동 파노라마 뷰',
      '옥상 정원 입주민 전용',
    ],
  },
];

export default function FloorPlan() {
  const [activeFloor, setActiveFloor] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const current = floorData[activeFloor];

  const handleFloorChange = (index: number) => {
    if (index === activeFloor) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveFloor(index);
      setIsTransitioning(false);
    }, 250);
  };

  return (
    <section id="floorplan" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-building-3-line text-base"></i>
            FLOOR PLAN
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">층별 시설 배치도</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            각 층의 시설 구성과 평면 배치를 확인하세요.<br />
            공공기여 시설부터 프리미엄 레지던스까지, 최적의 공간 설계를 제안합니다.
          </p>
        </div>

        {/* Floor Selector Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {floorData.map((floor, index) => (
            <button
              key={floor.id}
              onClick={() => handleFloorChange(index)}
              className={`relative flex flex-col items-center px-5 py-3 rounded-xl transition-all duration-300 cursor-pointer whitespace-nowrap border-2 ${
                activeFloor === index
                  ? `bg-gradient-to-br ${floor.color} text-white border-transparent shadow-lg scale-105`
                  : 'bg-white text-gray-600 border-gray-200 hover:border-teal-300 hover:bg-teal-50'
              }`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center mb-1 ${
                  activeFloor === index ? 'text-white' : 'text-gray-500'
                }`}
              >
                <i className={`${floor.icon} text-xl`}></i>
              </div>
              <span className="text-base font-bold">{floor.floor}</span>
              <span className={`text-xs mt-0.5 ${activeFloor === index ? 'text-white/80' : 'text-gray-400'}`}>
                {floor.label}
              </span>
            </button>
          ))}
        </div>

        {/* Main Content */}
        <div className={`transition-all duration-300 ${isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`}>
          {/* Floor Title Bar */}
          <div className={`bg-gradient-to-r ${current.color} rounded-t-2xl px-8 py-5 flex items-center justify-between`}>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className={`${current.icon} text-2xl text-white`}></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white">{current.title}</h3>
                <p className="text-white/80 text-sm">{current.subtitle}</p>
              </div>
            </div>
            <div className="hidden md:flex items-center gap-2 bg-white/20 rounded-lg px-4 py-2">
              <i className="ri-ruler-line text-white text-lg"></i>
              <span className="text-white font-semibold text-sm">{current.totalArea}</span>
            </div>
          </div>

          {/* Content Grid */}
          <div className="bg-gray-50 rounded-b-2xl border-2 border-t-0 border-gray-100 overflow-hidden">
            <div className="grid lg:grid-cols-5 gap-0">
              {/* Floor Plan Image */}
              <div className="lg:col-span-3 p-6">
                <div className="relative bg-white rounded-xl overflow-hidden shadow-md border border-gray-100 h-[420px]">
                  <img src={current.image} alt={`${current.floor} 평면도`} className="w-full h-full object-cover object-top" />
                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2 shadow-sm">
                    <span className="text-xs text-gray-500 font-medium">FLOOR PLAN</span>
                    <div className="text-sm font-bold text-gray-900">
                      {current.floor} {current.label}
                    </div>
                  </div>
                  <div className="absolute bottom-4 right-4 flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2 shadow-sm">
                    <i className="ri-compass-3-line text-teal-600"></i>
                    <span className="text-xs font-medium text-gray-600">N</span>
                  </div>
                </div>
              </div>

              {/* Info Panel */}
              <div className="lg:col-span-2 p-6 lg:pl-0">
                {/* Description */}
                <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 mb-4">
                  <p className="text-gray-600 text-sm leading-relaxed">{current.description}</p>
                </div>

                {/* Facilities List */}
                <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 mb-4">
                  <h4 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-layout-grid-line text-teal-600"></i>
                    시설 구성
                  </h4>
                  <div className="space-y-2.5">
                    {current.facilities.map((facility, idx) => (
                      <div
                        key={idx}
                        className="flex items-center justify-between py-2 px-3 rounded-lg hover:bg-gray-50 transition-colors group cursor-pointer"
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 bg-teal-50 rounded-md flex items-center justify-center group-hover:bg-teal-100 transition-colors">
                            <i className={`${facility.icon} text-teal-600 text-base`}></i>
                          </div>
                          <span className="text-sm font-medium text-gray-700">{facility.name}</span>
                        </div>
                        <span className="text-xs font-semibold text-teal-600 bg-teal-50 px-2.5 py-1 rounded-full">
                          {facility.detail}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Highlights */}
                <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
                  <h4 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-star-line text-teal-600"></i>
                    주요 특징
                  </h4>
                  <div className="space-y-2">
                    {current.highlights.map((highlight, idx) => (
                      <div key={idx} className="flex items-center gap-2.5">
                        <div className="w-5 h-5 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                          <i className="ri-check-line text-teal-600 text-xs"></i>
                        </div>
                        <span className="text-sm text-gray-600">{highlight}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Building Cross Section */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">건물 단면 구성도</h3>
          <div className="grid md:grid-cols-6 gap-3">
            {floorData
              .slice()
              .reverse()
              .map((floor, index) => {
                const actualIndex = floorData.length - 1 - index;
                return (
                  <button
                    key={floor.id}
                    onClick={() => handleFloorChange(actualIndex)}
                    className={`relative overflow-hidden rounded-xl p-4 transition-all duration-300 cursor-pointer group ${
                      activeFloor === actualIndex
                        ? `bg-gradient-to-br ${floor.color} shadow-lg scale-105`
                        : 'bg-gray-100 hover:bg-gray-200'
                    }`}
                  >
                    <div
                      className={`text-center ${
                        activeFloor === actualIndex ? 'text-white' : 'text-gray-700'
                      }`}
                    >
                      <div
                        className={`w-10 h-10 mx-auto mb-2 rounded-lg flex items-center justify-center ${
                          activeFloor === actualIndex ? 'bg-white/20' : 'bg-white'
                        }`}
                      >
                        <i
                          className={`${floor.icon} text-xl ${
                            activeFloor === actualIndex ? 'text-white' : 'text-gray-500'
                          }`}
                        ></i>
                      </div>
                      <div className="text-lg font-bold">{floor.floor}</div>
                      <div
                        className={`text-xs mt-1 ${
                          activeFloor === actualIndex ? 'text-white/80' : 'text-gray-500'
                        }`}
                      >
                        {floor.label}
                      </div>
                    </div>
                  </button>
                );
              })}
          </div>
        </div>

        {/* Summary Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="bg-teal-50 rounded-xl p-6 text-center">
            <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i className="ri-building-line text-2xl text-teal-600"></i>
            </div>
            <div className="text-3xl font-bold text-teal-700 mb-1">8+</div>
            <div className="text-sm text-gray-600">총 층수</div>
          </div>
          <div className="bg-amber-50 rounded-xl p-6 text-center">
            <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i className="ri-store-2-line text-2xl text-amber-600"></i>
            </div>
            <div className="text-3xl font-bold text-amber-700 mb-1">13+</div>
            <div className="text-sm text-gray-600">상업 매장</div>
          </div>
          <div className="bg-emerald-50 rounded-xl p-6 text-center">
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i className="ri-parking-box-line text-2xl text-emerald-600"></i>
            </div>
            <div className="text-3xl font-bold text-emerald-700 mb-1">500+</div>
            <div className="text-sm text-gray-600">주차 대수</div>
          </div>
          <div className="bg-rose-50 rounded-xl p-6 text-center">
            <div className="w-12 h-12 bg-rose-100 rounded-lg flex items-center justify-center mx-auto mb-3">
              <i className="ri-home-heart-line text-2xl text-rose-600"></i>
            </div>
            <div className="text-3xl font-bold text-rose-700 mb-1">30</div>
            <div className="text-sm text-gray-600">레지던스 세대</div>
          </div>
        </div>
      </div>
    </section>
  );
}
